import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { CoInvestorChartItem } from '../../../types';
import { ViewModel } from '../../../models/view.model';
import { roundTrackerMetricsFilteredByViewAtom } from '../state/RoundTrackerMetricsStateJ';

export const useMostCommonCoInvestors = (view: ViewModel): CoInvestorChartItem[] => {
  const filteredData = useAtomValue(roundTrackerMetricsFilteredByViewAtom(view.id));

  return useMemo(() => {
    if (!filteredData) {
      return [];
    }

    const coInvestorsFrequency: Record<string, { count: number; companies: Record<string, string> }> = {};

    filteredData.forEach((d) => {
      for (let i = 0; i < d.coInvestors.length; i++) {
        const ci = d.coInvestors[i];
        if (!coInvestorsFrequency[ci]) {
          coInvestorsFrequency[ci] = {
            count: 1,
            companies: { [d.company]: d.company },
          };
          continue;
        }
        if (coInvestorsFrequency[ci].companies[d.company]) {
          continue;
        }
        coInvestorsFrequency[ci].count++;
        coInvestorsFrequency[ci].companies[d.company] = d.company;
      }
    });

    const coInvestorsFrequencyArray: CoInvestorChartItem[] = [];

    for (const property in coInvestorsFrequency) {
      if (['Other common holders', 'Other investors'].includes(property)) {
        continue;
      }
      coInvestorsFrequencyArray.push({ name: property, deals: coInvestorsFrequency[property].count });
    }
    coInvestorsFrequencyArray.sort((a, b) => b.deals - a.deals);

    return coInvestorsFrequencyArray.slice(0, 10);
  }, [filteredData]);
};
